import { Fragment, useEffect, useState, useRef, useCallback } from "react";
import { Report } from "@mui/icons-material";
import { Text } from "../../FormControls/Text";
import { Stack } from "../../FormControls/Stack";
import { Input } from "../../FormControls/Input";
import { ScreenControl } from "../ScreenControl";
import { useDispatch, useSelector } from "react-redux";
import { DropdownSelect } from "../../FormControls/DropdownSelect";
import { Selector } from "../../FormControls/Selector";
import {
  setEmail,
  setUserName,
  setUserLastName,
  setPhone,
  setConfirmPhone,
  setPhoneExt,
  setDpi,
  getVerifyPoints,
  setUserSource,
  handleMinikitUser,
  setUserData
} from "../../../../main/slices/userSlice";

const InfoUser = ({ children, dispatch, user, typeInput, inputMode, onChange, pointsVerify, localValues }) => {

  const handleInputChange = useCallback((name, value) => {
    onChange(name, value);
  }, [onChange]);

  return (
    <Fragment>
      {/* LEGEND */}
      {children}
      <div style={{ marginBottom: "-1.5rem" }}></div>
      {/* BANK ACCOUNT INFORMATION */}
      <Stack flex={{ flexDirection: "column", gap: 1 }}>
        <div style={{ marginBottom: "1rem" }}></div>
        <Stack flex={{ flexDirection: "column" }}>
          {/* NAME AND LAST NAME */}
          <Stack flex={{ flexDirection: "row", gap: 25 }}>
            <Text classes={["description"]}> Nombre </Text>
            <Text classes={["description"]}> Apellido </Text>
          </Stack>
          <div style={{ marginBottom: "-0.15rem" }}></div>
          {
            //INVALIR EMAIL ALERT
            (user.name.value || user.last_name.value) &&
              (user.last_name.value || user.name.error) &&
              (user.name.error ? (
                <Text
                  classes={["description", "alignContent", "error"]}
                  style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
                >
                  <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                  Nombre inválido, verifica que no contenga números o caracteres
                  especiales (!, @, :, etc)
                </Text>
              ) : user.last_name.error ? (
                <Text
                  classes={["description", "alignContent", "error"]}
                  style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
                >
                  <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                  Apellido inválido, verifica que no contenga números o
                  caracteres especiales (!, @, :, etc)
                </Text>
              ) : (
                <Text></Text>
              ))
          }
          <Stack style={{ width: "100%" }}  flex={{ flexDirection: "row", gap: 10 }}>
            <div 
              classes= {
                "center"
              }
              style={{ flex: 1 }}
            >
              <Input
                attributes={{ value: user.name.value }}
                type="text"
                style={{
                  boxSizing: "border-box",
                  paddingLeft: "0.5rem",
                  width: "100%",
                  height: "2.5rem"
                }}
                classes={["marginTB1em", (user.name.value && user.name.error) ? "error" : ""]}
                onChange={({ target }) => handleInputChange("name", target.value)}
                placeHolder=""
              /> 
            </div>
            <div 
              classes= {
                "center"
              }
              style={{ flex: 1 }}
            > 
              <Input
                attributes={{ value: user.last_name.value }}
                type="text"
                style={{
                  boxSizing: "border-box",
                  paddingLeft: "0.5rem",
                  width: "100%",
                  height: "2.5rem"
                }}
                classes={["marginTB1em", (user.last_name.value && user.last_name.error) ? "error" : ""]}
                onChange={({ target }) => handleInputChange("last_name", target.value)}
                placeHolder=""
              />
            </div>
            
          </Stack>
        </Stack>

        <Stack flex={{ flexDirection: "column", gap: 5 }}>
          <Text classes={["description"]}> Teléfono </Text>
          {
            //INVALIR EMAIL ALERT
            (user.phone.value || user.extPhone.value) &&
              (user.phone.error || user.extPhone.error) &&
              (user.phone.error && user.phone.value ? (
                <Text
                  classes={["description", "alignContent", "error"]}
                  style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
                >
                  <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                  Número de teléfono inválido.
                </Text>
              ) : user.extPhone.error ? (
                <Text
                  classes={["description", "alignContent", "error"]}
                  style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
                >
                  <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                  Número de área inválido.
                </Text>
              ) : (
                <Text></Text>
              ))
          }
          
          <Stack flex={{  justifyContent: "space-between", gap: 16 }} >
            {/* PHONE */}
            <div 
              classes= {
                "center"
              }
              style={{ flex: 2 }}
            > 
              <Input
                type={typeInput}
                classes={["marginTB1em"]}
                style={{ paddingLeft: "0.5rem" }}
                attributes={{ value: user.extPhone.value, inputMode: inputMode }}
                placeHolder="Área"
                onChange={({ target }) => handleInputChange("extPhone", target.value)}
              />
            </div>
            <div 
              classes= {
                "center"
              }
              style={{ flex: 10 }}
            > 
              <Input
                type={typeInput}
                classes={["marginTB1em"]}
                attributes={{ value: localValues.phone ?? user.phone.value, inputMode: inputMode }}
                placeHolder="Número telefónico"
                onChange={({ target }) => handleInputChange("phone", target.value)}
              />
            </div>
          </Stack>
          <Text classes={["description"]}> </Text>
        </Stack>
        
        {/* INVALID PHONE ALERT */}
        {(user.confirmPhone.value || user.confirmPhone.error) &&
          user.confirmPhone.value &&
          user.phone.value != user.confirmPhone.value && (
            <Text
              classes={["description", "alignContent", "error"]}
              style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
            >
              <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
              El número de teléfono no coincide.
            </Text>
          )}
        <Input
          attributes={{ value: localValues.confirmPhone ?? user.confirmPhone.value, inputMode: inputMode }}
          type="number"
          inputMode="numeric"
          placeHolder="Confirmar Número Telefónico"
          classes={[
            "marginTB1em",
            user.confirmPhone.value &&
            user.confirmPhone.error &&
            user.phone.value != user.confirmPhone.value
              ? "error"
              : "",
          ]}
          onChange={({ target }) => handleInputChange("confirmPhone", target.value)}
        />

        <div style={{ marginBottom: "0.5rem" }}></div>
        <Stack flex={{ flexDirection: "column" }}>
          {/* DOC NUMBER */}
          <Text classes={["description"]}>
            {" "}
            Número de documento de identificación{" "}
          </Text>
          <div style={{ marginBottom: "-0.15rem" }}></div>
          {
            //INVALIR DPI ALERT
            user.dpi.value && user.dpi.error && (
              <Text
                classes={["description", "alignContent", "error"]}
                style={{ justifyContent: "flex-start", margin: "0.5em 0" }}
              >
                <Report sx={{ fontSize: "1em", margin: "0 0.5em" }}></Report>
                El documento de identificación debe tener {user.country.value == "CR" ? "entre 9 y 12" : "13"} dígitos
              </Text>
            )
          }
          <Input
            attributes={{ value: user.dpi.value, inputMode: inputMode }}
            type={typeInput}
            classes={["marginTB1em"]}
            onChange={({ target }) => handleInputChange("dpi", target.value)}
            placeHolder=""
          />
        </Stack>

      </Stack>
    </Fragment>
  );
};

const ScreenLegend = () => (
  <Stack flex={{ flexDirection: "column" }}>
    <Text classes={["title", "center"]}>
      {" "}Información Personal{" "}
    </Text>
    <div style={{ marginBottom: "0.25rem" }}></div>
    <Text classes={["subtitle"]}>
      {" "}Completa tu perfil con tus datos personales y asegura que tu cuenta esté lista para operar.{" "}
    </Text>
  </Stack>
);

export const FormInfoUser = ({ path }) => {
  const [pointsVerify, setPointsVerify] = useState([]);
  const [typeInput, setTypeInput] = useState("number");
  const [inputMode, setInputMode] = useState("numeric");
  const state = useSelector(({ user }) => user);
  const stateEmail = useSelector(({ user }) => user.email);
  const timerRefs = useRef({}); // Timers por campo
  const [localValues, setLocalValues] = useState({});
  const dispatch = useDispatch();

  const updateInfoUser = (key, value) => {
    const payload = { [key]: value };
    const Data = { payload, action: "update", userId: state.idWLD };
  
    dispatch(handleMinikitUser(Data))
      .unwrap()
      .then(({ response }) => {
        dispatch(setUserData(response.user));
      });
  };

  const handleChange = (key, value) => {
    // setLocalValues(prev => ({ ...prev, [key]: value }));
    if (key === "email"){ dispatch(setEmail({ value, error: !value })); }
    else if (key === "phone"){ dispatch(setPhone({ value, error: !value })); }
    else if (key === "extPhone"){ dispatch(setPhoneExt({ value, error: !value })); }
    else if (key === "confirmPhone"){ dispatch(setConfirmPhone({ value, error: false })); }
    else if (key === "dpi"){ dispatch(setDpi({ value, error: !value })); }
    else if (key === "name"){ dispatch(setUserName({ value, error: !value })); }
    else if (key === "last_name"){ dispatch(setUserLastName({ value, error: !value })); }
  };

  // Asignar el valor de los puntos para verificarce
  useEffect(() => {
    (async () => {
      try {
        const { response } = await dispatch(getVerifyPoints()).unwrap();
        setPointsVerify(response);
      } catch (error) {
        console.error("Error al recuperar los puntos de verificación:", error);
        return false;
      }
    })();
  }, [dispatch]);

  const route = () => {
    // FOR THE PATH "phone"
    return { 
      disabled:
        state.name.error ||
        state.last_name.error ||
        state.phone.error ||
        state.dpi.error ||
        (!state.extPhone.value || state.extPhone.error)||
        (state.confirmPhone.error && state.confirmPhone.value != state.phone.value)
      };
  };

  return (
    <Fragment>
      <div style={{ padding: "0 1.5rem" }}>
        {/* USER INFO COMPONENT */}
        <InfoUser
          dispatch={dispatch}
          onChange={handleChange}
          user={state}
          typeInput={typeInput}
          inputMode={inputMode}
          pointsVerify={pointsVerify}
          localValues={localValues}
        >
          
          <ScreenLegend></ScreenLegend>
          <div style={{ marginBottom: "1rem" }}></div>
        </InfoUser>
      </div>
      {/* CONTROLLER */}
      <ScreenControl
        btncolor={"cobrarBtn"}
        btnText={"Continuar"}
        {...route()}>
      </ScreenControl>
    </Fragment>
  );
};
